import MainTheme from './mainTheme';

const Styles = {
  MainTheme: MainTheme,
};

export default Styles;
